import React from 'react';
import ProgressBar from './ProgressBar';
import { scoreColor, formatTime } from './diagnosticHelpers';

const Stat = ({ label, value, tone }) => (
  <div className="dxr-stat">
    <span className="dxr-stat-value" style={tone ? { color: tone } : undefined}>{value}</span>
    <span className="dxr-stat-label">{label}</span>
  </div>
);

const DifficultyRow = ({ label, data }) => {
  if (!data || data.attempted === 0) {
    return (
      <div className="dxr-diff-row">
        <div className="dxr-diff-head">
          <span className="dxr-diff-name">{label}</span>
          <span className="dxr-diff-muted">No questions</span>
        </div>
        <ProgressBar value={0} />
      </div>
    );
  }
  return (
    <div className="dxr-diff-row">
      <div className="dxr-diff-head">
        <span className="dxr-diff-name">{label}</span>
        <span className="dxr-diff-val" style={{ color: scoreColor(data.accuracy) }}>
          {data.accuracy}% <span className="dxr-diff-sub">({data.correct}/{data.attempted})</span>
        </span>
      </div>
      <ProgressBar value={data.accuracy} />
    </div>
  );
};

// Section 2 — Knowledge Performance. Purely academic; no behavioural metrics.
const KnowledgePanel = ({ knowledge }) => {
  if (!knowledge) return null;
  const d = knowledge.difficulty || {};

  return (
    <div className="dxr-card">
      <div className="dxr-kp-grid">
        <div className="dxr-kp-stats">
          <Stat label="Overall Accuracy" value={`${Math.round(knowledge.score)}%`} tone={scoreColor(knowledge.score)} />
          <Stat label="Correct" value={knowledge.correct} tone="#16a34a" />
          <Stat label="Wrong" value={knowledge.wrong} tone="#dc2626" />
          <Stat label="Attempted" value={`${knowledge.attempted}/${knowledge.total}`} />
          <Stat label="Avg Time / Question" value={formatTime(knowledge.avg_time_per_question_sec)} />
        </div>

        <div className="dxr-kp-difficulty">
          <h4 className="dxr-subhead">Difficulty-wise Accuracy</h4>
          <DifficultyRow label="Easy" data={d.easy} />
          <DifficultyRow label="Medium" data={d.medium} />
          <DifficultyRow label="Hard" data={d.hard} />
        </div>
      </div>
    </div>
  );
};

export default KnowledgePanel;
